import{supabaseClient}from'../net/supabase-client.js?v=20260801-token-hash-1';

async function rpc(name,params={}){
  const{data,error}=await supabaseClient.rpc(name,params);
  if(error)throw error;
  return data;
}

export const listPlayerPokemon=(states=['free','in_team'])=>
  rpc('list_player_pokemon',{p_states:states});

export const migrateCollection=(pokemon,requestId)=>
  rpc('migrate_collection',{p_pokemon:pokemon,p_request_id:requestId});

export const claimOfflineHunt=(requestId,exitAt=null)=>
  rpc('claim_offline_hunt',{p_request_id:requestId,p_exit_at:exitAt});

export const requestEncountersRpc=(payload,requestId)=>{
  const params={
    p_route:Math.trunc(Number(payload.route)||1),
    p_count:Math.trunc(Number(payload.count??30)||30),
    p_request_id:requestId,
    p_route_type:payload.routeType||'normal',
    p_zone_special:!!payload.zoneSpecial,
  };
  // Omit null species so PostgREST matches the overload by named args cleanly.
  const species=payload.species?String(payload.species).trim().toLowerCase():'';
  if(species)params.p_species=species;
  return rpc('request_encounters',params);
};

export const invokeShinyAltar=(species,requestId)=>
  rpc('invoke_shiny_altar',{p_species:String(species||'').trim().toLowerCase(),p_request_id:requestId});

export const resolveFishingCastRpc=(payload,requestId)=>
  rpc('resolve_fishing_cast',{
    p_spot:String(payload.spot||'pier').trim().toLowerCase(),
    p_fish_level:Math.max(1,Math.min(300,Math.trunc(Number(payload.fishLevel)||1))),
    p_rod:String(payload.rod||'').trim().toLowerCase(),
    p_bait:payload.bait?String(payload.bait).trim().toLowerCase():null,
    p_request_id:requestId,
  });

export const requestAltarEncountersRpc=(payload,requestId)=>{
  const params={
    p_route:Math.trunc(Number(payload.route)||1),
    p_count:Math.trunc(Number(payload.count??30)||30),
    p_request_id:requestId,
    p_route_type:payload.routeType||'normal',
    p_species:String(payload.species||'').trim().toLowerCase(),
    p_zone_special:false,
  };
  return rpc('request_altar_encounters',params);
};

/** Fase F: só encounter_id — sem overload legado. */
export const attemptCaptureRpc=(payload,requestId)=>
  rpc('attempt_capture',{
    p_encounter_id:payload.encounterId,
    p_ball:payload.ball,
    p_request_id:requestId,
    p_moves:payload.moves||[],
  });

export const breedCreateEggRpc=(payload,requestId)=>
  rpc('breed_create_egg',{
    p_parent_a:payload.parentA,
    p_parent_b:payload.parentB,
    p_request_id:requestId,
    p_mode:payload.mode==='free'?'free':'pheromones',
    p_stone_payments:payload.stonePayments||[],
    p_double_stones:!!payload.doubleStones,
  });

export const breedHatchRpc=(payload,requestId)=>
  rpc('breed_hatch',{
    p_egg_id:payload.eggId,
    p_request_id:requestId,
    p_moves:payload.moves||[],
  });

export const breedTickEggsRpc=(count=1)=>
  rpc('breed_tick_eggs',{p_count:count});

export const migrateInventory=(items,requestId)=>
  rpc('migrate_inventory',{p_items:items,p_request_id:requestId});

export const migrateProgress=(progress,requestId)=>
  rpc('migrate_progress',{p_progress:progress,p_request_id:requestId});

export const prestigeTrainerRpc=(requestId)=>
  rpc('prestige_trainer',{p_request_id:requestId});

export const grantPokemonXp=(grants,requestId)=>
  rpc('grant_pokemon_xp',{p_grants:grants,p_request_id:requestId});

export const ensureStarterPokemon=(pokemon,requestId)=>
  rpc('ensure_starter_pokemon',{p_pokemon:pokemon,p_request_id:requestId});

export const evolvePlayerPokemon=(payload,requestId)=>
  rpc('evolve_player_pokemon',{
    p_pokemon_id:payload.pokemonId,
    p_next_species:payload.nextSpecies,
    p_method:payload.method,
    p_request_id:requestId,
    p_stone_slug:payload.stoneSlug||null,
  });

export const investTrainerTalentRpc=(key,requestId)=>
  rpc('invest_trainer_talent',{p_key:key,p_request_id:requestId});

export const respecTrainerTalentsRpc=(requestId)=>
  rpc('respec_trainer_talents',{p_request_id:requestId});

export const listPlayerEggs=(states=['incubating'])=>
  rpc('list_player_eggs',{p_states:states});

export const consumeInventoryItem=(slug,qty,requestId)=>
  rpc('consume_inventory_item',{p_slug:slug,p_qty:qty,p_request_id:requestId});

export const listPlayerInventory=()=>rpc('list_player_inventory');

export const setActivePokemon=(pokemonId,requestId)=>
  rpc('set_active_pokemon',{p_pokemon_id:pokemonId,p_request_id:requestId});

export const setTeamRoster=(reserveIds,requestId)=>
  rpc('set_team_roster',{
    p_reserve_ids:(Array.isArray(reserveIds)?reserveIds:[]).map(id=>String(id)).filter(Boolean),
    p_request_id:requestId,
  });

export const restoreGhostCapturesRpc=(pokemon,requestId)=>
  rpc('restore_ghost_captures',{p_pokemon:pokemon,p_request_id:requestId});

/** Lê progresso autoritativo (RLS: só o próprio user). */
export async function getPlayerProgress(){
  const{data,error}=await supabaseClient
    .from('player_progress')
    .select('trainer_level,trainer_peak_level,trainer_xp,prestige,defeated,captured,shiny_research,kill_counts,route_level,last_sync_at,session_seed,trainer_talents,free_respecs')
    .maybeSingle();
  if(error)throw error;
  return data||null;
}

export const reportSession=(payload,requestId)=>
  rpc('report_session',{
    p_route:payload.route,
    p_elapsed_sec:payload.elapsedSec,
    p_events:payload.events||[],
    p_request_id:requestId,
    p_metrics:payload.metrics||null,
  });

export const resolveCombatResult=(payload,requestId)=>
  rpc('resolve_combat_result',{
    p_mode:payload.mode,
    p_payload:payload.payload,
    p_request_id:requestId,
  });
